import React from 'react';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';

import logoImg from 'Console/assets/images/nexthink-whiteout.svg';

const styles = (theme) => ({
    bodyContainer: {
        flex: 1,
        backgroundColor: theme.palette.primary.main,
    },
    img: {
        margin: 'auto',
        display: 'block',
    },
});
const SplashView = ({ classes }) => (
    <div id="yeself-splashView-container" className={classes.bodyContainer}>
        <Grid
            container
            direction="column"
            justify="center"
            alignItems="center"
            style={{
                /** @todo temporal hack no success with material ui  */
                top: '50%',
                position: 'absolute',
                transform: 'translateY(-50%)',
            }}
        >
            <Grid id="yeself-splashView-logo-wrapper" item>
                <img
                    id="yeself-splashView-logo"
                    className={classes.img}
                    alt="logo"
                    src={logoImg}
                    height={150}
                />
            </Grid>
        </Grid>
    </div>
);

export default withStyles(styles)(SplashView);
